module.exports = __webpack_public_path__ + "static/img/1-7.2a4afeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-7.png
// module id = 261
// module chunks = 0